import type { AxiosResponse } from "axios";

import { HttpApiService } from "@/shared/services/httpApi.service";

/** Active TRANSFIYA participant bank as served by `GET /internal/payments/transfiya-banks`. */
export interface TransfiyaBank {
  /** Participant entity code the payout sends as `destination.bank_code`. */
  code: string;
  name: string;
}

/**
 * Participant-bank directory for TRANSFIYA (ACH en línea) payouts. The list comes from the corridor
 * provider's directory (rail-named endpoint — the API hides which PSP serves it) and feeds the
 * destination-bank selector of the dispersion form; the chosen `code` goes verbatim into
 * `destination.bank_code`.
 */
export class TransfiyaBanksService {
  private static BASE_URL = "/internal/payments/transfiya-banks";

  static async list(): Promise<AxiosResponse<TransfiyaBank[]>> {
    return HttpApiService.get<TransfiyaBank[]>(this.BASE_URL);
  }
}
